import fetch from './fetch'

export function checkLogin (data) {
  return fetch({
    url: 'login/checkLogin',
    method: 'post',
    data
  })
}
export function getCaptcha (data, responseType = 'arraybuffer') {
  return fetch({
    url: 'login/getCaptcha',
    method: 'get',
    data,
    responseType
  })
}
